<template>
  <div class="custom-shape-divider-bottom-1684861291">
    <svg
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1200 120"
      preserveAspectRatio="none"
      style="background: black"
    >
      <path d="M1200 0L0 0 892.25 114.72 1200 0z" class="shape-fill"></path>
    </svg>
  </div>
</template>

<style scoped>
.custom-shape-divider-bottom-1684861291 {
  bottom: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  line-height: 0;
  transform: rotate(180deg);
}

.custom-shape-divider-bottom-1684861291 svg {
  position: relative;
  display: block;
  width: calc(142% + 1.3px);
  height: 130px;
}

.custom-shape-divider-bottom-1684861291 .shape-fill {
  fill: #4d9c76;
}
</style>
